import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceFormFieldsVisibility  {
    _originalTypeClassName = "zERP.BO.InvoiceFormFieldsVisibility";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceFormFieldsVisibility.translate = translateService;
}
this.Issuer = false;
this.Counterpart = false;
this.Quantity = false;
this.UnitPrice = false;
this.SpendingRequest = false;
this.SelfPricing = false;
this.IncomeClassifications = false;
this.ExpensesClassifications = false;
this.Goods = false;
this.Services = false;
this.OtherGoods = false;
this.Assets = false;
this.CorrelatedInvoices = false;
this.SendToAccounting = false;
this.IsDeliveryNote = false;
this.DeliveryInfo = false;
this.NetAmount = false;
this.VATRate = false;
this.VATAmount = false;
this.GrossValue = false;
this.TaxesOnInvoice = false;
this.TaxesPerLine = false;
this.PaymentMethods = false;
this.Summary = false;
this.PaymentOrders = false;
this.IncomeReceipt = false;
this.DeliveryNotes = false;
this.SeriesAndAA = false;
this.InvoiceFormFieldsVisibilityKey = null;
this._key = this.InvoiceFormFieldsVisibilityKey = 0; 
}

static translate: TranslateService;
_key: any;
Issuer:any;
Counterpart:any;
Quantity:any;
UnitPrice:any;
SpendingRequest:any;
SelfPricing:any;
IncomeClassifications:any;
ExpensesClassifications:any;
Goods:any;
Services:any;
OtherGoods:any;
Assets:any;
CorrelatedInvoices:any;
SendToAccounting:any;
IsDeliveryNote:any;
DeliveryInfo:any;
NetAmount:any;
VATRate:any;
VATAmount:any;
GrossValue:any;
TaxesOnInvoice:any;
TaxesPerLine:any;
PaymentMethods:any;
Summary:any;
PaymentOrders:any;
IncomeReceipt:any;
DeliveryNotes:any;
SeriesAndAA:any;
private _InvoiceFormFieldsVisibilityKey:any;
get InvoiceFormFieldsVisibilityKey(): any {
    return this._InvoiceFormFieldsVisibilityKey;
  }
set InvoiceFormFieldsVisibilityKey(value: any) {
    this._InvoiceFormFieldsVisibilityKey = value;
    this._key = value;
  }

static CanBeDeiveryNote(invoiceType: any): any{return CLMS.Framework.Number.LessThan(() => Domain.InvoiceFormFieldsVisibility.InvoiceTypeEnumToInt(invoiceType), () => Domain.InvoiceFormFieldsVisibility.InvoiceTypeEnumToInt(Domain.InvoiceType.Item21));
}
static GetGoodTypeByInvoiceType(invoiceType: any): any{let invoiceTypeDec = Domain.InvoiceTypeValueObject.InvoiceTypeToDecimal(invoiceType);
let invoiceTypeNumber = parseInt((Math.floor(invoiceTypeDec)) as any);
let transactionItemTypes = [];
if (CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 1) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 5) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 9)) {transactionItemTypes?.add(Domain.TransactionItemType.Good);}
if (CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 1) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 2) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 5)) {transactionItemTypes?.add(Domain.TransactionItemType.Service);}
if (CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 1) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 2) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 3) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 5) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 6) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 7) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 8) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 10) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 11) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 12) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 13) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 14) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 15) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 16) || CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 17)) {transactionItemTypes?.add(Domain.TransactionItemType.Other);}
if (CLMS.Framework.Number.Equal(() => invoiceTypeNumber, () => 1)) {transactionItemTypes?.add(Domain.TransactionItemType.Asset);}
return transactionItemTypes;
}
static HasQuantity(invoiceType: any): any{return CLMS.Framework.Number.LessThan(() => Domain.InvoiceFormFieldsVisibility.InvoiceTypeEnumToInt(invoiceType), () => Domain.InvoiceFormFieldsVisibility.InvoiceTypeEnumToInt(Domain.InvoiceType.Item21)) || invoiceType == Domain.InvoiceType.Item93;
}
static HasUnitPrice(invoiceType: any): any{return CLMS.Framework.Number.LessThan(() => Domain.InvoiceFormFieldsVisibility.InvoiceTypeEnumToInt(invoiceType), () => Domain.InvoiceFormFieldsVisibility.InvoiceTypeEnumToInt(Domain.InvoiceType.Item21));
}
static InvoiceTypeEnumToInt(invoiceType: any): any{let invoiceTypeStr = invoiceType + "";
invoiceTypeStr = Joove.Common.replaceAll(invoiceTypeStr, "Item", "");
let value = 0;
try {value = CLMS.Framework.Integer.Parse(invoiceTypeStr);}
catch (x) {console.warn("Could not parse InvoiceType: " + invoiceTypeStr);}
return value;
}
static Reset($this: any): any{$this.Issuer = true;
$this.Counterpart = true;
$this.Quantity = true;
$this.UnitPrice = true;
$this.SpendingRequest = true;
$this.SelfPricing = true;
$this.IncomeClassifications = true;
$this.ExpensesClassifications = true;
$this.Goods = true;
$this.Services = true;
$this.OtherGoods = true;
$this.Assets = true;
$this.CorrelatedInvoices = true;
$this.SendToAccounting = true;
$this.IsDeliveryNote = true;
$this.DeliveryInfo = true;
$this.NetAmount = true;
$this.VATRate = true;
$this.VATAmount = true;
$this.GrossValue = true;
$this.TaxesOnInvoice = true;
$this.TaxesPerLine = true;
$this.PaymentMethods = true;
$this.Summary = true;
$this.PaymentOrders = true;
$this.IncomeReceipt = true;
$this.DeliveryNotes = true;
$this.SeriesAndAA = true;
}
static Update($this: any, transactionType: any,invoiceTypeValueObject: any,erpStatus: any,isDeliveryNote: any,isFromExternalSource: any): any{Domain.InvoiceFormFieldsVisibility.Reset($this);
let invoiceType = invoiceTypeValueObject?.Code;
if (transactionType == Domain.TransactionType.Income || transactionType == Domain.TransactionType.Accounting) {$this.Issuer = false;$this.PaymentOrders = false;}
if (transactionType == Domain.TransactionType.Income) {$this.IncomeClassifications = false;}
if (transactionType == Domain.TransactionType.Expense || transactionType == Domain.TransactionType.Accounting) {$this.Counterpart = false;$this.IncomeReceipt = false;}
if (transactionType == Domain.TransactionType.Expense) {$this.ExpensesClassifications = false;$this.PaymentOrders = true;}
if (!(Domain.InvoiceFormFieldsVisibility.HasQuantity(invoiceType))) {$this.Quantity = false;}
if (!(Domain.InvoiceFormFieldsVisibility.HasUnitPrice(invoiceType))) {$this.UnitPrice = false;}
if (invoiceType != Domain.InvoiceType.Item51) {$this.CorrelatedInvoices = false;}
if (transactionType != Domain.TransactionType.Expense) {$this.SelfPricing = false;}
if (invoiceType == Domain.InvoiceType.Item171) {$this.SendToAccounting = false;}
if (!(Domain.InvoiceFormFieldsVisibility.CanBeDeiveryNote(invoiceType))) {$this.IsDeliveryNote = false;}
if (invoiceType != Domain.InvoiceType.Item93 && !(isDeliveryNote)) {$this.DeliveryInfo = false;}
if ((transactionType != Domain.TransactionType.Income && transactionType != Domain.TransactionType.Accounting && !(invoiceTypeValueObject?.IsIssuedByUs)) || erpStatus != Domain.BookInvoiceERPStatus.Draft) {$this.SeriesAndAA = false;}
if (invoiceType == Domain.InvoiceType.Item93) {$this.NetAmount = false;$this.VATRate = false;$this.VATAmount = false;$this.GrossValue = false;$this.TaxesOnInvoice = false;$this.TaxesPerLine = false;$this.PaymentMethods = false;$this.ExpensesClassifications = false;$this.IncomeClassifications = false;$this.Summary = false;$this.DeliveryNotes = false;}
let validTransactionItemTypes = Domain.InvoiceFormFieldsVisibility.GetGoodTypeByInvoiceType(invoiceType);
$this.Goods = validTransactionItemTypes?.linq?.contains(Domain.TransactionItemType.Good);
$this.Services = validTransactionItemTypes?.linq?.contains(Domain.TransactionItemType.Service);
$this.OtherGoods = validTransactionItemTypes?.linq?.contains(Domain.TransactionItemType.Other);
$this.Assets = validTransactionItemTypes?.linq?.contains(Domain.TransactionItemType.Asset);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InvoiceFormFieldsVisibilityKey == null || $this.InvoiceFormFieldsVisibilityKey == 0;
            }


}